/** Captured before Supabase consumes the URL fragment during auth initialization. Never persist tokens. */
export type PasswordSetupMode = "invite" | "recovery";
export function detectPasswordSetupMode(hash: string): PasswordSetupMode | null {
  const fragment = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const mode = fragment.get("type");
  if (!fragment.has("access_token") || !fragment.has("refresh_token")) return null;
  return mode === "invite" || mode === "recovery" ? mode : null;
}
export const initialPasswordSetupMode =
  typeof window === "undefined" ? null : detectPasswordSetupMode(window.location.hash);
